import { API_URL } from ".";

export const getRoutes = () => ({
  // ==================== مسیرهای اصلی ====================
  BaseAgreementsRoutes: `${API_URL}base-agreements/`,
  BaseAgreementsActiveRoutes: `${API_URL}base-agreements/active`,
  BaseAgreementItemsRoutes: `${API_URL}base-agreement-item/`,
  BaseAgreementFollowupsRoutes: `${API_URL}base-agreement-followup/`,
  AgreementsRoutes: `${API_URL}agreements/`,
  AgreementsByCustomerRoutes: `${API_URL}agreements/by-customer/`,
  AgreementServicesRoutes: `${API_URL}agreement-services/`,
  ServicesRoutes: `${API_URL}services/`,
  ServiceItemsRoutes: `${API_URL}service-items/`,
  SystemsRoutes: `${API_URL}systems/`,
  UsersRoutes: `${API_URL}user/`,
  FollowupRoutes: `${API_URL}followup-groups/`,
  BaseDefinitionWitTypehRoutes: `${API_URL}base-definition/type/`,
  BaseDefinitionRoutes: `${API_URL}base-definition/`,
  TransactionRoutes: `${API_URL}transactions/`,
  TaskLogRoutes: `${API_URL}task-logs/`,
  ServiceGroupsRoutes: `${API_URL}service-groups/`,

  // ==================== مسیرهای اضافی ====================
  TasksRoutes: `${API_URL}tasks/`,
  FollowupsScheduleRoutes: `${API_URL}followup-schedule/`,
  ProvincesRoutes: `${API_URL}provinces/`,
  CitiesRoutes: `${API_URL}cities/`,
  BanksRoutes: `${API_URL}banks/`,
  BankAccountsRoutes: `${API_URL}bank-accounts/`,
  SalesFunnelRoutes: `${API_URL}sale-funnel/`,
  SalesFunnelItemsRoutes: `${API_URL}sale-funnel-item/`,
  ResultPayRoutes: `${API_URL}result-pay/`,
  RequestPaymentRoutes: `${API_URL}request-payment/`,
  UserInfoRoutes: `${API_URL}user-info/`,
  WebSystemRoutes: `${API_URL}web-system/`,
  RelatedUserRoutes: `${API_URL}related-user/`,
  AppUserWebSystemRoutes: `${API_URL}appUser-websystem/`,
  ZarinpalRoutes: `${API_URL}zarinpal/`,
  UserByRoleRoutes: `${API_URL}user/getByRole/`,
  /** برای dropdown و لیست سبک: همان مسیر + نقش + "/simple" (بدون Include؛ سریع‌تر) */
  UserByRoleOptimizedRoutes: `${API_URL}user/optimized/getByRole/`,
  UsersOptimizedRoutes: `${API_URL}user/optimized`,
  UsersOptimizedPagedRoutes: `${API_URL}user/optimized/paged`,
  UserByRoleOptimizedPagedRoutes: `${API_URL}user/optimized/getByRole/`,
  UserByExcelRoutes: `${API_URL}user/by-excel/`,
  BaseDefinitionTypeRoutes: `${API_URL}base-definition/type/`,
  FollowupScheduleByParentRoutes: `${API_URL}followup-schedule/by-parent/`,
  FollowupScheduleSmsRoutes: `${API_URL}followup-schedule/sms`,
  SmsHistoryRoutes: `${API_URL}sms-history`,

  // ==================== مسیرهای دسترسی‌ها ====================
  UserPermissionsRoutes: `${API_URL}userpermission/`,

  // ==================== مسیرهای فرایندها ====================
  ProcessesRoutes: `${API_URL}processes/`,
  ProcessSectionsRoutes: `${API_URL}process-sections/`,
  StagesRoutes: `${API_URL}stages/`,
  ReasonSolutionsRoutes: `${API_URL}reason-solutions/`,
});
